<template>
    <div class="prepare min-height">
        <div class="prepare-type flex align-center">
            <span :class="{'active':type === 1}" @click="type = 1">发函机构</span>
            <span :class="{'active':type === 2}" @click="type = 2">自主注册</span>
        </div>
        <PrepareInvitation v-if="type === 1"/>
        <PrepareRegister v-if="type === 2"/>


    </div>
</template>

<script>
import PrepareInvitation from './children/prepare-invitation'
import PrepareRegister from './children/prepare-register'
export default {
    name: "labels",
    data() {
        return {
            type:1
        }
    },
    created() {
        this.$emit("setIndex", this.$route.path, "预备会员  / ", false, 'icon-gonggao');
    },
    components: {
        PrepareInvitation,
        PrepareRegister
    },
    methods: {},
    filters: {},
    watch: {},
}
</script>

<style scoped lang="scss">
.prepare{

    .prepare-type{
        border-bottom: 1px solid #ccc;
        
        padding: 0 30px;
        span{
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: 80px;
            height: 58px;
            text-align: center;
            font-size: 16px;
            margin-right: 30px;
            cursor: pointer;
            &.active{
                color: #0d7fd7;
                border-bottom: 3px solid #0d7fd7;
            }
        }
    }
}
</style>